var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  Errors: () => Errors
});
var Errors;
(function(Errors2) {
  Errors2[Errors2["mathError"] = 2e3] = "mathError";
  Errors2[Errors2["mathFunctionError"] = 2001] = "mathFunctionError";
  Errors2[Errors2["mathEvaluateError"] = 2002] = "mathEvaluateError";
  Errors2[Errors2["modelError"] = 3e3] = "modelError";
  Errors2[Errors2["modelSingleOptionTypeInvalid"] = 3001] = "modelSingleOptionTypeInvalid";
})(Errors || (Errors = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Errors
});
